export default __webpack_public_path__ + "static/media/0c.23196227.jpg";